export default __webpack_public_path__ + "static/media/CONSTAN.f030ac01.TTF";